module.exports = __webpack_public_path__ + "img/lock-screen3.a5c1191d.png";